import * as React from "react";
import { SvgIcon } from "@material-ui/core";

// Google Material Symbols Outlined: local_police, 24px, weight 400, fill 0.
// Source: https://github.com/google/material-design-icons/blob/master/symbols/web/local_police/materialsymbolsoutlined/local_police_24px.svg
// Apache-2.0; see material-symbols-LICENSE.txt.
export const LocalPolice = (props) => (
  <SvgIcon viewBox="0 -960 960 960" titleAccess="Law enforcement officer (PLEO)" {...props}>
    <path d="m368-336 112-84 110 84-42-136 112-88H524l-44-136-44 136H300l110 88-42 136ZM480-80q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Zm0-84q104-33 172-132t68-220v-189l-240-90-240 90v189q0 121 68 220t172 132Zm0-316Z" />
  </SvgIcon>
);
